exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".feature-group .list-group-item.finished{background-color:#dff0d8}.feature-group .list-group-item .row{margin-left:-15px!important}.feature-group .list-group-item .title{width:80%;float:left;font-size:1.8rem}.feature-group .list-group-item .votes{font-size:3rem;font-weight:100;float:right;text-align:right}.feature-group .list-group-item .votes i.vote{padding-left:5px}.feature-group .list-group-item .votes i.vote.voted,.feature-group .list-group-item .votes i.vote:hover{color:#bc3e25}.feature-group .list-group-item .description{font-size:1.4rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/featureboard.less
 ** module id = 775
 ** module chunks = 0
 **/